import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import BottomBar from "../../Components/bottomBar/bottomBar";
import Alert from "../../Components/alert/Alert";
import { handleColor } from "../../services/Functions";
import ReportDepartaments from "../Reports/reportDepartaments";
import AddUser from "../Registration/Users/addUser";
import AltUser from "../Registration/Users/altUser";
import DelUser from "../Registration/Users/delUser";
import Users from "../Reports/reportUsers";
import UserAlterPassword from "../User/userAlterPassword";
import UserPreference from "../User/userPreference";
import { Redirect } from "react-router-dom";
import "./prelude.css";
import { DrawerMenu } from "../../Components/DrawerMenu/DrawerMenu";

const PreludeUserPreferences = () => {
  const [activeTab, setActiveTab] = React.useState("infos");
  return (
    <>
      <header>
        <Top_bar />{" "}
      </header>
      <div className="prelude_container">
        <DrawerMenu>
          <Sidebar
            isMobile
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></Sidebar>
        </DrawerMenu>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab}></Sidebar>
      </div>
      <BottomBar></BottomBar>
    </>
  );
};

class Sidebar extends React.Component {
  state = { render: false, message: "", click: false, users: false };

  async componentWillMount() {
    let viewport = document.querySelector("meta[name=viewport]");
    viewport.setAttribute(
      "content",
      viewport.content + ", height=" + window.innerHeight
    );
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  usersClick = () => {
    this.setState({ users: true });
  };

  render() {
    const { show, message, users } = this.state;
    const items = [
      { id: "lg1", label: "Dados Pessoais", eventKey: "infos" },
      { id: "lg2", label: "Usuários", eventKey: "users" },
    ];
    let admin = localStorage.getItem("@oee-monitor/admin");

    return (
      <Tab.Container activeKey={this.props.activeTab}>
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1 ">
            <div
              className={this.props.isMobile ? "sidebar2-mobile" : "sidebar2"}
            >
              <Col className="sidebarColumn" mountOnEnter unmountOnExit>
                <ListGroup>
                  {items.map((item) => {
                    if (item.eventKey === "users" && admin != 1) return null;

                    return this.props.isMobile ? (
                      <Col key={item.id} xs={12}>
                        <ListGroup.Item
                          id={item.id}
                          onClick={() => {
                            this.props.setActiveTab(item.eventKey);
                            if (item.eventKey === "users") {
                              this.usersClick();
                            }
                          }}
                          className="listGroup"
                          eventKey={item.eventKey}
                        >
                          {item.label}
                        </ListGroup.Item>
                      </Col>
                    ) : (
                      <ListGroup.Item
                        key={item.id}
                        id={item.id}
                        onClick={() => {
                          this.props.setActiveTab(item.eventKey);
                          if (item.eventKey === "users") {
                            this.usersClick();
                          }
                        }}
                        className="listGroup d-none d-md-block"
                        eventKey={item.eventKey}
                      >
                        {item.label}
                      </ListGroup.Item>
                    );
                  })}
                </ListGroup>
              </Col>
            </div>
            <Col
              className="col3"
              style={{
                top: "5%",
                marginLeft: "1.5%",
               
                width: "100%",
                overflow: "auto",
              }}
            >
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              <Tab.Content>
                <Tab.Pane eventKey="users">
                  {users == true ? (
                    <Redirect to={{ pathname: "/usuarios" }}></Redirect>
                  ) : null}
                </Tab.Pane>
                {!this.props.isMobile && (
                  <Tab.Pane mountOnEnter unmountOnExit eventKey="infos">
                    {this.handleClick ? (
                      <UserPreference></UserPreference>
                    ) : null}
                  </Tab.Pane>
                )}
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default PreludeUserPreferences;
